import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { reduxForm } from 'redux-form';
import { ActionForm } from './ActionForm';
import { axiosInstance } from '../../../utils';
import { flashActions } from '../../../actions';

import './CancelHoldInvoice.scss';

const OffHoldForm = ({
  handleSubmit,
  submitFailed,
  closeModal,
  documentName,
  id,
  reloadPage,
  setProcessing,
}) => {
  const newState = useSelector(state => state.form.OffHold);
  const { values, syncErrors } = newState || {};

  const dispatch = useDispatch();

  const textField = [
    {
      name: 'note',
      component: 'input',
      type: 'textarea',
      label: 'Add a note for this action which will be displayed in the Document History for future reference:',
      placeholder: 'Write your message...',
    },
  ];

  const onSubmit = async () => {
    setProcessing(true);
    closeModal();
    const note = values && values.note ? values.note : '';

    axiosInstance
      .patch(`v1/documents/${id}/invoice/update_status`, { status_note: note, commit: 'unhold' })
      .then(() => {
        setProcessing(false);
        dispatch(flashActions.showSuccess('The invoice has been taken off hold'));
        reloadPage();
      })
      .catch(error => {
        setProcessing(false);
        dispatch(flashActions.showError(error));
      });
  };

  return (
    <div className="cancel-hold-invoice-container">
      <h3 className="cancel-hold-invoice-title">Take off hold?</h3>
      <p className="cancel-hold-invoice-text">Are you sure you want to take '{documentName}' off hold?</p>
      <ActionForm
        handleSubmit={handleSubmit}
        submitFailed={submitFailed}
        values={values}
        syncErrors={syncErrors}
        onSubmit={onSubmit}
        field={textField}
        closeModal={closeModal}
        buttonText="Take off hold"
        actionButtonColor="green"
      />
    </div>
  );
};

export const OffHold = reduxForm({
  form: 'OffHold',
})(OffHoldForm);
